import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";

import Registration from "../registration";
import { warn } from "../../modules/messages";
import { getEntity } from "../../modules/crudOperations";
import PasswordModal from "../../components/registration/detail/passwordModal";

const OldRegistration = () => {
  const intl = useIntl();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [password, setPassword] = useState(
    location && location.state && location.state.smsCode
  );
  useEffect(() => {
    setPassword(location && location.state && location.state.smsCode);
  }, [location]);

  const [modalOpen, setModalOpen] = useState();
  const handleSetPassword = useCallback((pass) => {
    setPassword(pass);
    setModalOpen();
  }, []);

  const [contract, setContract] = useState();
  const handleSetContract = useCallback(
    (value, result) => {
      if (result === 409) {
        warn(
          intl.formatMessage({
            id: "registration.security.wrong",
            defaultMessage: "Byl zadán nekorektní přístupový kód.",
          })
        );
        navigate("/");
      }
      setContract(value);
    },
    [intl, navigate]
  );

  const handleContractLoad = useCallback(
    (setLoading) => {
      password !== undefined && password
        ? getEntity("contract", id, setLoading, handleSetContract, {
            password,
          })
        : setModalOpen(true);
    },
    [id, password, handleSetContract]
  );

  return (
    <>
      {modalOpen && (
        <PasswordModal open={modalOpen} onSetPassword={handleSetPassword} />
      )}
      <Registration
        contract={contract}
        oldPassword={password}
        onContractLoad={handleContractLoad}
      />
    </>
  );
};

export default OldRegistration;
